import React from 'react';
import '../../../css/CTAFooter.css';

export const CTAFooter = () => {
    return (
        <nav className="ctaFooterContainer">
            <div className="ctaFooterButtonContainer">
                <a href="/refer-service-company">
                    <button className="ctaFooterRealtorsButton">
                        Realtors Refer Your Favorite SC
                    </button>
                    <button className="ctaFooterRealtorsButtonSmall">
                        Refer Service Pro
                    </button>
                </a>
                <a href="/service-company-registration">
                    <button className="ctaFooterServiceProButton">
                        Service Pro Join Us Here
                    </button>
                    <button className="ctaFooterServiceProButtonSmall">
                        Service Pro Join
                    </button>
                </a>
            </div>
        </nav>
    );
};
